export enum ACCOUNT_TYPE {
  REQUESTOR = 'requestor',
  GROUND_FREIGHT = 'ground_freight',
}

export enum permissionsRole{
  adminRequestor='ADMIN_REQUESTOR',
  adminTrucker = 'ADMIN_TRUCKING',
}